import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Pages from "./pages";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="App">
      <Header />
      <ToastContainer />
      <Pages />
      <Footer />
    </div>
  );
}

export default App;
